export const REWARD_POINTS_PAYMENT_METHOD_ID = 'pm_reward_points'
